import { Layout, Card, Loading } from 'element-react';
import SwiperCore, { Navigation, Pagination, Autoplay, Scrollbar, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useTranslation } from 'react-i18next';
import welcomeBannerImg from '../assets/imgs/home-02.png'
import welcomeBannerImg2 from '../assets/imgs/home-03.jpg'
import welcomeBannerMobile from '../assets/imgs/BAINUB_HOME_MOBILE_1.png'

import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
import 'swiper/components/scrollbar/scrollbar.scss';

import { Link } from "react-router-dom";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);

export default function HomeSlider({ slidesPerView, spaceBetween, suppliers, Keyboard, Mousewheel, loading }) {
    return (
        <>
          <Swiper
            modules={[Autoplay, Pagination, Navigation]}
            loop={true}
            spaceBetween={30}
            slidesPerView={1}
            centeredSlides={true}
            className="HomeSlider"
          >
            <SwiperSlide className="homeslide-02">
              <div className='slider-container logged-in-banner'>
                <div className='banner02-content-Container' style={{paddingTop: '37px'}}>
                  <h1>CNC & Metal Fabrication Services<span className="primary-color">.</span></h1>
                  <div className='banner-bg-primary'>
                    <div className='circle'></div><h3>Looking for Specialized Metal Fabrication Solutions?</h3>
                  </div>
                  
                  <p>Use our search engine to find verified suppliers for: CNC Machining, Sheet Metal Cutting, <br></br>Bending, Welding, Assembly, and Finishes & Coatings. All in one place. 
                    <br></br>
                    100% Comission-Free Trading Operations
                  </p>

                  <Link to="/search-result-ng/BAINUBMF009/All" className="link-exploreCategory">
                      <p>
                          Expore category ＞
                      </p>
                  </Link>
                </div>
              </div>
            
            </SwiperSlide>
          </Swiper>
        </>
      );
}
